import { Component } from '@angular/core';
import { HeaderComponent } from '../plantilla/header/header.component';
import { FooterComponent } from '../plantilla/footer/footer.component';
import { MapaComponent } from '../mapa/mapa.component';
// import { OpinionesComponent } from '../opiniones/opiniones.component';
// import { PreContactoComponent } from '../pre-contacto/pre-contacto.component';
import { HeroComponent } from '../hero/hero.component';
import { CartComponent } from '../cart/cart/cart.component';
import { ProductListComponent } from '../cart/restaurant/product-list/product-list.component';
// import { ProductListComponent } from '../cart/product-list/product-list.component';
// import { DestacadoComponent } from '../destacado/destacado.component';
// import { FaqsComponent } from '../faqs/faqs.component';
// import { CarruselVehiculosComponent } from '../carrusel-vehiculos/carrusel-vehiculos.component';
// import { CochesDestacadoComponent } from '../coches-destacado/coches-destacado.component';
// import { ServiciosDestacadosComponent } from '../servicios-destacados/servicios-destacados.component';
// import { CochesServiciosComponent } from '../coches-servicios/coches-servicios.component';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    MapaComponent,
    CartComponent,
    // OpinionesComponent,
    // PreContactoComponent,
    // FaqsComponent,
    HeroComponent,
    ProductListComponent,
    // CarruselVehiculosComponent,
    // DestacadoComponent,
    // CochesDestacadoComponent,
    // ServiciosDestacadosComponent,
    // CochesServiciosComponent,
  ],
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.scss',
})
export class InicioComponent {}
